import React from "react";

const ArrowForwardSvg = ({ fill = "#5663F2", ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Arrow forward</title>
      <path
        d="M16.1693 11H0V9H16.1693L8.57433 1.405L10 0L20 10L10 20L8.57433 18.595L16.1693 11Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowForwardSvg;
